// plants/use-plants.jsx — the plants model for the panel, live.
//
// Readings, thresholds, photos and care notes are plain entities in
// hass.states, so the home-screen line costs nothing extra. The 30 days of
// hourly readings behind "last watered" and the charts come from
// recorder/statistics_during_period, only while the Plants page is open,
// refreshed every half hour (statistics compile hourly).

import * as React from 'react';
import { PLANTS, ids, readPlants } from './model.js';

const REFRESH_MS = 30 * 60 * 1000;
export const HISTORY_DAYS = 30;

export function usePlants(hass) {
  const states = hass?.states;
  return React.useMemo(() => readPlants(states), [states]);
}

// { [sensor entity_id]: [{start, mean, max}] } or null while loading.
export function usePlantHistory(hass, enabled) {
  const conn = hass?.connection;
  const [rows, setRows] = React.useState(null);
  React.useEffect(() => {
    if (!enabled || !conn?.sendMessagePromise) return undefined;
    let cancelled = false;
    const load = () => {
      const start = new Date(Date.now() - HISTORY_DAYS * 86400000);
      start.setMinutes(0, 0, 0);
      conn.sendMessagePromise({
        type: 'recorder/statistics_during_period',
        start_time: start.toISOString(),
        statistic_ids: PLANTS.map((p) => ids(p.id).moisture),
        period: 'hour',
        types: ['mean', 'max'],
      }).then((r) => { if (!cancelled) setRows(r || {}); })
        .catch(() => { if (!cancelled) setRows({}); });
    };
    load();
    const t = setInterval(load, REFRESH_MS);
    return () => { cancelled = true; clearInterval(t); };
  }, [conn, enabled]);
  return rows;
}
